(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days && days > 0) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function initPopup(root) {
    if (!root || root.getAttribute('data-amc-bound') === '1') return;
    root.setAttribute('data-amc-bound', '1');

    var enabled = root.getAttribute('data-enabled') === 'true';
    var testMode = root.getAttribute('data-test-mode') === 'true';
    var seconds = parseInt(root.getAttribute('data-delay-seconds') || '2', 10);
    var days = parseInt(root.getAttribute('data-delay-days') || '2', 10);
    var cookieName = 'amc-global-popup-' + (root.getAttribute('data-section-id') || 'default');
    var timer = null;

    if (!enabled && !testMode) return;
    if (window.location.pathname === '/challenge' || window.location.pathname === '/password') return;
    if (!testMode && days > 0 && getCookie(cookieName)) return;

    var video = root.querySelector('[data-amc-global-popup-video]');
    var playBtn = root.querySelector('[data-amc-global-popup-play]');

    function playVideo() {
      if (!video) return;
      try {
        video.muted = false;
        video.defaultMuted = false;
        video.volume = 1;
        video.setAttribute('controls', '');
        video.controls = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(function () {
              root.classList.add('is-playing');
            })
            .catch(function () {
              // If unmuted play blocked, retry muted then expose unmute via controls
              video.muted = true;
              video.play().then(function () {
                root.classList.add('is-playing');
              }).catch(function () {});
            });
        } else {
          root.classList.add('is-playing');
        }
      } catch (e) {}
    }

    function pauseVideo() {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
      root.classList.remove('is-playing');
    }

    function resetVideo() {
      pauseVideo();
      if (!video) return;
      try {
        video.currentTime = 0;
        video.controls = false;
        video.removeAttribute('controls');
        video.muted = false;
      } catch (e) {}
    }

    function open() {
      root.hidden = false;
      root.classList.add('is-open');
      root.classList.remove('is-playing');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close(persist) {
      root.classList.remove('is-open');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      resetVideo();
      if (persist !== false && days > 0) {
        setCookie(cookieName, '1', days);
      }
    }

    root.querySelectorAll('[data-amc-global-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        playVideo();
      });
    }

    if (video) {
      video.addEventListener('play', function () {
        root.classList.add('is-playing');
        video.controls = true;
      });
      video.addEventListener('pause', function () {
        if (video.currentTime > 0 && !video.ended) {
          root.classList.remove('is-playing');
        }
      });
      video.addEventListener('ended', function () {
        root.classList.remove('is-playing');
        video.controls = false;
        video.removeAttribute('controls');
      });
    }

    var cta = root.querySelector('[data-amc-global-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        if (days > 0) setCookie(cookieName, '1', days);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close(true);
    });

    timer = window.setTimeout(open, Math.max(0, seconds) * 1000);

    document.addEventListener(
      'shopify:section:unload',
      function () {
        if (timer) window.clearTimeout(timer);
        close(false);
      },
      { once: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-amc-global-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var node =
      e.target.querySelector('[data-amc-global-popup]') ||
      (e.target.matches && e.target.matches('[data-amc-global-popup]') ? e.target : null);
    if (node) initPopup(node);
  });
})();
